"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPropertyValue = exports.getPropertyValue = void 0;
exports.getUnitLabel = getUnitLabel;
exports.getAmountFormatSelector = getAmountFormatSelector;
exports.getFieldGroupFieldName = getFieldGroupFieldName;
const React = __importStar(require("react"));
const AmountFormatSelector = __importStar(require("@genesys/client-core/lib/amount-format-selector"));
const property_1 = require("@genesys/property");
const uom_1 = require("@genesys/uom");
const product_properties_1 = require("@genesys/shared/lib/product-properties");
const getPropertyValue = (productId, resultType, propertyName, getAmountFormat, propertyValue) => {
    // TODO: Use the format selector.
    if (propertyValue && propertyValue.type === "amount") {
        const amount = property_1.PropertyValue.getAmount(propertyValue);
        const res = getFieldGroupFieldName(productId, resultType, propertyName);
        const amountFormat = getAmountFormat(res.fieldGroup, res.fieldName, amount);
        return (0, product_properties_1.getValue)(propertyValue, amountFormat);
    }
    return !propertyValue ? "" : property_1.PropertyValue.toString(propertyValue);
};
exports.getPropertyValue = getPropertyValue;
function getUnitLabel(productId, resultType, propertyName, getAmountFormat, propertyValueSets) {
    const propertyValueSetWithPropertyName = propertyValueSets.find(x => x && property_1.PropertyValueSet.hasProperty(propertyName, x));
    const propertyValue = propertyValueSetWithPropertyName &&
        property_1.PropertyValueSet.get(propertyName, propertyValueSetWithPropertyName);
    if (!propertyValue || propertyValue.type !== "amount") {
        return "";
    }
    // TODO: Use the format selector.
    if (propertyValue && propertyValue.type === "amount") {
        const amount = property_1.PropertyValue.getAmount(propertyValue);
        const res = getFieldGroupFieldName(productId, resultType, propertyName);
        const amountFormat = getAmountFormat(res.fieldGroup, res.fieldName, amount);
        const unitFormat = uom_1.Format.getUnitFormat(amountFormat.unit, uom_1.UnitsFormat);
        return `[${unitFormat && unitFormat.label}]`;
    }
    return "";
}
function getAmountFormatSelector(productId, resultType, getAmountFormat, propertyValueSets, propertyName) {
    const propertyValueSetWithPropertyName = propertyValueSets.find(x => x && property_1.PropertyValueSet.hasProperty(propertyName, x));
    const propertyValue = propertyValueSetWithPropertyName &&
        property_1.PropertyValueSet.get(propertyName, propertyValueSetWithPropertyName);
    if (!propertyValue || propertyValue.type !== "amount") {
        return null;
    }
    const res = getFieldGroupFieldName(productId, resultType, propertyName);
    const amountFormat = getAmountFormat(res.fieldGroup, res.fieldName, property_1.PropertyValue.getAmount(propertyValue));
    // gg easy
    return (React.createElement(React.Fragment, null,
        "[",
        React.createElement(AmountFormatSelector.FormatSelectorWithMutations, { amountFormat: amountFormat, fieldGroup: res.fieldGroup, fieldName: res.fieldName, propertyType: "amount" }),
        "]"));
}
const formatPropertyValue = (propertyValue) => {
    let display = !propertyValue ? "" : property_1.PropertyValue.toString(propertyValue);
    // TODO: Use the format selector.
    if (propertyValue && propertyValue.type === "amount") {
        const amount = property_1.PropertyValue.getAmount(propertyValue);
        const quantityUnits = uom_1.Format.getUnitsForQuantity(amount.unit.quantity);
        const unit = quantityUnits[0];
        const val = uom_1.Amount.valueAs(unit, amount);
        const unitFormat = uom_1.Format.getUnitFormat(unit, uom_1.UnitsFormat);
        display = val.toFixed(2) + " " + (unitFormat && unitFormat.label);
    }
    return display;
};
exports.formatPropertyValue = formatPropertyValue;
const perfParamRegex = /^(.+?)?_(.+?)$/;
function getFieldGroupFieldName(productId, resultType, propertyName) {
    const matches = perfParamRegex.exec(
    // resultKey
    propertyName);
    if (!matches) {
        return undefined;
    }
    const [, , fieldName] = matches;
    return {
        fieldGroup: `${resultType === "Property" ? "Settings" : "PerfParam"}.${productId}`,
        fieldName: fieldName
    };
}
//# sourceMappingURL=functions.js.map